(() => {
  const BAR_SELECTOR = '[data-product-buy-bottom-test]';
  const MAIN_PRODUCT_SELECTOR = '[id^="MainProduct-"]';

  class ProductBuyBottomTestScroll {
    constructor(bar) {
      this.bar = bar;
      this.mainProductSection = document.querySelector(MAIN_PRODUCT_SELECTOR);

      this.productArea =
        this.mainProductSection?.querySelector('.product') ||
        this.mainProductSection;

      this.rafId = null;

      this.handleViewportChange = this.handleViewportChange.bind(this);
      this.updateVisibility = this.updateVisibility.bind(this);

      if (!this.bar || !this.productArea) {
        if (this.bar) {
          this.hide();
        }
        return;
      }

      this.updateVisibility();

      window.addEventListener('scroll', this.handleViewportChange, {
        passive: true
      });

      window.addEventListener('resize', this.handleViewportChange, {
        passive: true
      });
    }

    handleViewportChange() {
      if (this.rafId !== null) return;

      this.rafId = window.requestAnimationFrame(() => {
        this.updateVisibility();
        this.rafId = null;
      });
    }

    updateVisibility() {
      if (!this.bar || !this.productArea) return;

      const rect = this.productArea.getBoundingClientRect();
      const viewportHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        0;

      /*
       * Show only when the bottom of the main product area
       * has reached the bottom edge of the current viewport.
       *
       * Before that:
       * - product media / info is still being viewed
       * - bottom buy bar stays hidden
       *
       * After that:
       * - bottom buy bar appears
       *
       * If the user scrolls back up, it hides again.
       */
      const shouldShow = rect.bottom <= viewportHeight;

      if (shouldShow) {
        this.show();
      } else {
        this.hide();
      }
    }

    show() {
      this.bar.classList.remove('product-buy-bottom--scroll-hidden');
      this.bar.classList.add('product-buy-bottom--scroll-visible');
      this.bar.setAttribute('aria-hidden', 'false');
    }

    hide() {
      this.bar.classList.remove('product-buy-bottom--scroll-visible');
      this.bar.classList.add('product-buy-bottom--scroll-hidden');
      this.bar.setAttribute('aria-hidden', 'true');
    }

    destroy() {
      window.removeEventListener('scroll', this.handleViewportChange);
      window.removeEventListener('resize', this.handleViewportChange);

      if (this.rafId !== null) {
        window.cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
    }
  }

  const instances = new WeakMap();

  function initBar(bar) {
    if (!bar || instances.has(bar)) return;

    const instance = new ProductBuyBottomTestScroll(bar);
    instances.set(bar, instance);
  }

  function initAll() {
    document.querySelectorAll(BAR_SELECTOR).forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  /*
   * Shopify theme editor support.
   * Re-initialize when a section is dynamically reloaded.
   */
  document.addEventListener('shopify:section:load', (event) => {
    event.target
      .querySelectorAll?.(BAR_SELECTOR)
      .forEach(initBar);
  });
})();
